import "../styles/ExperienceCard.css";

type ExperienceProps = {
  id: number;
  expPosition: string;
  expCompany: string;
  expDuties: string[];
  expDate: string;
  expLink: string;
  index: number;
};

function ExperienceCard(props: ExperienceProps) {
  return (
    <div
      className="expInfo"
      data-aos="zoom-in"
      data-aos-duration="500"
      data-aos-once="true"
    >
      <div
        className={`expText ${props.index % 2 === 0 ? "row" : "rowReverse"}`}
      >
        <div className="expCompanyBlock">
          <div className="expPosition">{props.expPosition}</div>
          <div className="expCompany">{props.expCompany}</div>
          <a
            className="expLink"
            href={props.expLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            About The Company
          </a>
        </div>
        <div className="expDivider" />
        <ul className="expDuties">
          {props.expDuties.map((duty, index) => (
            <li className="expDutiesPoint" key={index}>
              {duty}
            </li>
          ))}
        </ul>
      </div>
      <div className="expDate">
        {new Date(props.expDate).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
        })}
      </div>
    </div>
  );
}

export default ExperienceCard;
